<div class="progress-bar-wrapper">
  <div class="status-bar" [style.width.%]="statusBarTotalLength">
    <div class="current-status" [style.width.%]="statusBarCurrentLength"></div>
  </div>
  <ul class="nc-progress-bar">
    <li
      *ngFor="let section of sectionsList; let idx = index"
      class="section"
      [ngClass]="section.classes"
    >
      {{ section.title }}
    </li>
  </ul>
</div>
